import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t } = useTranslation('common');
  
  const scrollToReservation = () => {
    const element = document.getElementById('reservation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="accueil" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-16 sm:pt-20 md:pt-0"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=Breathtaking%20Moroccan%20desert%20landscape%20at%20golden%20hour%2C%20magnificent%20sand%20dunes%20stretching%20endlessly%20to%20horizon%2C%20warm%20amber%20and%20golden%20lighting%20creating%20dramatic%20shadows%2C%20traditional%20Berber%20architecture%20silhouettes%20in%20far%20distance%2C%20pristine%20untouched%20Sahara%20scenery%2C%20sophisticated%20travel%20destination%20photography%20with%20rich%20textures%20and%20spectacular%20sunset%20sky%2C%20luxury%20tourism%20atmosphere%20without%20any%20vehicles&width=1920&height=1080&seq=hero-morocco-pure-landscape&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'scroll'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 text-center text-white py-8 sm:py-0">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold mb-4 sm:mb-6 leading-tight">
            {t('heroTitle')} 
            <span className="text-gold-400 block mt-2">{t('heroTitleHighlight')}</span>
          </h1>
          
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-6 sm:mb-8 text-gray-200 leading-relaxed px-2 sm:px-4">
            {t('heroDescription')}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center px-2 sm:px-4">
            <button 
              onClick={scrollToReservation}
              className="w-full sm:w-auto bg-blue-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-blue-700 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-line mr-2"></i>
              {t('bookNow')}
            </button>
            
            <a 
              href="https://wa.me/212666204299" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-full sm:w-auto bg-transparent border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-white hover:text-charcoal-800 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              {t('whatsapp')}
            </a>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-4 sm:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-xl sm:text-2xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
